// extracted by mini-css-extract-plugin
export default {"content":"Routers_content__-Doht"};